export default __webpack_public_path__ + "static/media/gribble-eggs-logo.76e8c15d.svg";